<template>
<div>
    <div v-if="newProgramsAvailable[iframe_src + iframeQueryString]" class="new-program-available">
        <router-link :to="newProgramsAvailable[iframe_src + iframeQueryString]['route']">{{ newProgramsAvailable[iframe_src + iframeQueryString]['description'] }}  Try it here...</router-link>
    </div>
    <section class="iframe-wrapper">
        <iframe id="legacyiframe" :src="iframeSource"></iframe>
	</section>
</div>
</template>

<script>
export default {
	name: 'IFrame',
    props: ['iframe_src'],
	data() {
        return {
            loading: true,
            message: 'iFrame Test',
            iframeQueryString: '',
            iframeSource: '',
            token: '',
            doInterval: null,
            newProgramsAvailable: {
                'cashierreport.php': { route: '/reports/cashier-commission-report', description: 'The new design for the Cashier Commission Sales Report is now available!' },
                'clientmaintenance.php': { route: '/profile', description: 'The new design for the Company Profile program is now available!' },
                'departmentmaintenance.php': { route: '/inventory/departments', description: 'The new design for the Departments program is now available!' },
                'categorymaintenance.php': { route: '/inventory/categories', description: 'The new design for the Categories program is now available!' },
                'categoryprofitmaintenance.php': { route: '/inventory/profit-margins', description: 'The new design for the Profit Margins program is now available!' },
                'emailblastmaintenance.php': { route: '/promotions/email-blasts', description: 'The new design for the Email Blasts program is now available!' },
                'priceoverridemaintenance.php': { route: '/inventory/price-overrides', description: 'The new design for the Price Overrides program is now available!' },
                'producttagmaintenance.php': { route: '/inventory/product-tags', description: 'The new design for the Product Tags program is now available!' },
                'salesreport.php': { route: '/reports/daily-cash', description: 'The new Daily Cash Report is now available!' },
                'orderitemreport.php': { route: '/reports/order-items', description: 'The new Item Taxable Report is now available!' },
                'inventoryreport.php': { route: '/reports/inventory-management', description: 'The new Inventory Management Report is now available!' },
                'purchaseordermaintenance.php': { route: '/orders-sales/purchase-orders', description: 'The new design for the Purchase Order program is now available!' },
                'membermaintenance.php': { route: '/range-memberships/members', description: 'The new design for the Manage Members program is now available!' },
                'membershipmaintenance.php': { route: '/range-memberships/memberships', description: 'The new design for the Membership Management program is now available!' },
                'membershippagemaintenance.php': { route: '/range-memberships/membership-application-pages', description: 'The new design for the Membership Application Pages program is now available!' },
                'rentalproductmaintenance.php': { route: '/range-memberships/rentals', description: 'The new design for the Rental Products program is now available!' },
                'subscriptionreport.php': { route: '/range-memberships/members', description: 'Subscriptions are now managed directly in the new Manage Members program!' },
                'rangeschedulemaintenance.php': { route: '/range-memberships/range-schedule', description: 'The new design for the Range Schedule program is now available!' },
                'discountreport.php': { route: '/reports/discount-report', description: 'The new design for the Discount Report is now available!' },
                'rangewaivermaintenance.php': { route: '/range-memberships/waivers', description: 'The new design for the Liability Waivers program is now available!' },
                'devicelogmaintenence.php': { route: '/pos/register-logs', description: 'The new design for the Register Logs program is now available!' },
                'devicelicensemaintenence.php': { route: '/pos/register-codes', description: 'The new design for the Register Codes program is now available!' },
                'reasoncodemaintenence.php': { route: '/pos/reason-codes', description: 'The new design for the Reason Codes program is now available!' },
                'resrtictionmaintenance.php': { route: '/inventory/state-restrictions', description: 'The new design for the State Restrictions program is now available!' },
                'inventorymanagementreport.php': { route: '/reports/inventory-management', description: 'The new Inventory Management Report is now available!' },
            }
        }
    },
    created() {
        // if (!this.getUser.user_id) {
        //     this.$router.push('/login?login_required=1')
        // }
        // any additional new program links for admins or for sandbox / local testing?
        if (this.getUser.user_type_code.indexOf('ADMIN') > -1) {
            this.newProgramsAvailable['clientmaintenance.php'] = { route: '/admin/clients', description: 'The new design for the Clients program is now available!' };
            this.newProgramsAvailable['domainnamemaintenance.php'] = { route: '/admin/client-domains', description: 'The new Client Domains program is now available!' };
        } else if (document.location.hostname.indexOf('sandbox') > -1 || document.location.hostname.indexOf('.test') > -1) {
            this.newProgramsAvailable['batchordermaintenance.php'] = { route: '/orders-sales/reorder-cart', description: 'The new design for the Reorder Cart is now available!' };
        }
        this.loadIFrame()
    },
    watch: {
		'$route.path' (newPath, oldPath) {
            if (newPath != oldPath) {
                this.loadIFrame()
            }
        },
	},
    computed: {
        showDeprecated() {
            if (this.$route.path.indexOf('menu') > -1) {
                return true
            }
            if (this.$route.path.indexOf('dashboard') > -1) {
                return true
            }
            return false
        }
    },
    beforeRouteLeave: function(to, from, next) {
        clearInterval(this.doInterval)
        next();
    },
    methods: {
        loadIFrame() {
            // check for test domain
            //let hostName = window.location.hostname.indexOf('.test') > -1 ? "https://cds.test" : "https://" + window.location.hostname
            let hostName = window.location.hostname.indexOf('.test') > -1 ? "https://cdsapi.test:8086" :  "https://" + window.location.hostname
            // parse the route query object if present
            let queryStringParts = []
            if (this.$route.query) {
                for (let [key, value] of Object.entries(this.$route.query)) {
                    queryStringParts.push(key + '=' + value)
                }
            }
            this.iframeQueryString = queryStringParts.join('&')
            // NOTE: we now use a static token to preserve login with legacy programs
			let key = 'cds_rocks'
            this.token = btoa(key + ':' + this.getUser.user_name)
            this.iframeSource = hostName + "/legacy/" + this.iframe_src + '?fd_token=' + this.token + (this.iframeQueryString ? '&' : '') + this.iframeQueryString
            this.loading = false;
        },
        renewLogin() {
			this.apiCall({ destination: 'get_logged_in_user' })
        }

    }
}
</script>
<style lang="scss" scoped>
.iframe-wrapper {
    overflow: hidden;
}
.new-program-available {
    position: fixed;
    top: 40px;
    left: 0;
    width: 100%;
    text-align: center;
    background-color: #4abdac;
    padding: 0.25em;
    a {
        color: white;
    }
}
iframe {
    width: 100%;
    min-height: 93vh;
    margin-top: -2.75em;
    border: 0 none;
}
</style>
